export const friendInvitations = [
    {
        "id": 1,
        "user": {
            "id": 101,
            "fullName": "Nguyễn Văn A",
            "avatar": "https://i.pravatar.cc/150?img=1"
        },
        "sendDate": "2024-03-10T14:32:00Z",
        "type": {id: 4, name: "Tìm kiếm qua số điện thoại"},
        "invitationContent": "Xin chào bạn, mình là Nguyễn Văn A. Mình thấy bạn là một người rất thú vị qua các bài đăng và bình luận. Mình rất mong có thể kết bạn với bạn để cùng nhau chia sẻ những câu chuyện thú vị trong cuộc sống, học hỏi và phát triển bản thân. Hy vọng chúng ta có thể cùng nhau trao đổi nhiều điều bổ ích và tạo nên một mối quan hệ bạn bè thật sự ý nghĩa. Rất mong nhận được sự đồng ý từ bạn. Cảm ơn bạn rất nhiều và chúc bạn một ngày vui vẻ!"
    },
    {
        "id": 2,
        "user": {
            "id": 102,
            "fullName": "Trần Thị B",
            "avatar": "https://i.pravatar.cc/150?img=2"
        },
        "sendDate": "2024-03-11T09:20:00Z",
        "type": {id: 3, name: "Muốn kết bạn"},
        "invitationContent": "Mình thấy bạn rất thú vị, làm quen nhé!"
    },
    {
        "id": 3,
        "user": {
            "id": 103,
            "fullName": "Lê Văn C",
            "avatar": "https://i.pravatar.cc/150?img=3"
        },
        "sendDate": "2024-03-12T08:45:00Z",
        "type": {id: 2, name: "Từ nhóm trò chuyện"},
        "invitationContent": "Hi bạn, kết bạn để trò chuyện nha."
    },
    {
        "id": 4,
        "user": {
            "id": 104,
            "fullName": "Phạm Thị D",
            "avatar": "https://i.pravatar.cc/150?img=4"
        },
        "sendDate": "2024-03-13T17:10:00Z",
        "type": {id: 3, name: "Muốn kết bạn"},
        "invitationContent": "Rất vui nếu được làm bạn với bạn."
    },
    {
        "id": 5,
        "user": {
            "id": 105,
            "fullName": "Võ Văn E",
            "avatar": "https://i.pravatar.cc/150?img=5"
        },
        "sendDate": "2024-03-14T12:05:00Z",
        "type": {id: 1, name: "Từ cửa sổ trò chuyện"},
        "invitationContent": "Mình thấy bạn có cùng sở thích, kết bạn nhé!"
    },
    {
        "id": 6,
        "user": {
            "id": 106,
            "fullName": "Đỗ Thị F",
            "avatar": "https://i.pravatar.cc/150?img=6"
        },
        "sendDate": "2024-03-15T11:40:00Z",
        "type": {id: 3, name: "Muốn kết bạn"},
        "invitationContent": "Chào bạn, mình muốn làm quen."
    },
    {
        "id": 7,
        "user": {
            "id": 107,
            "fullName": "Ngô Văn G",
            "avatar": "https://i.pravatar.cc/150?img=7"
        },
        "sendDate": "2024-03-16T15:50:00Z",
        "type": {id: 2, name: "Từ nhóm trò chuyện"},
        "invitationContent": "Kết bạn với mình nhé, rất vui được làm quen."
    }
]

export const friendRecommendations = [
    {
      id: 1,
      user: { id: 201, fullName: "Nguyễn Minh Khoa", avatar: "https://i.pravatar.cc/150?img=12" },
      type: { id: 1, name: "Có thể bạn quen" },
      countGroup: 0
    },
    {
      id: 2,
      user: { id: 202, fullName: "Lê Hoàng Yến", avatar: "https://i.pravatar.cc/150?img=13" },
      type: { id: 1, name: "Có thể bạn quen" },
      countGroup: 0
    },
    {
      id: 3,
      user: { id: 203, fullName: "Trần Nhật Quang", avatar: "https://i.pravatar.cc/150?img=14" },
      type: { id: 2, name: "Nhóm chung" },
      countGroup: 4
    },
    {
      id: 4,
      user: { id: 204, fullName: "Phạm Thị Hương", avatar: "https://i.pravatar.cc/150?img=15" },
      type: { id: 1, name: "Có thể bạn quen" },
      countGroup: 0
    },
    {
      id: 5,
      user: { id: 205, fullName: "Võ Tuấn Anh", avatar: "https://i.pravatar.cc/150?img=16" },
      type: { id: 1, name: "Có thể bạn quen" },
      countGroup: 0
    },
    {
      id: 6,
      user: { id: 206, fullName: "Đặng Thị Ngọc", avatar: "https://i.pravatar.cc/150?img=17" },
      type: { id: 1, name: "Có thể bạn quen" },
      countGroup: 0
    },
    {
      id: 7,
      user: { id: 207, fullName: "Ngô Minh Tuấn", avatar: "https://i.pravatar.cc/150?img=18" },
      type: { id: 2, name: "Nhóm chung" },
      countGroup: 3
    },
    {
      id: 8,
      user: { id: 208, fullName: "Huỳnh Bảo Trâm", avatar: "https://i.pravatar.cc/150?img=19" },
      type: { id: 1, name: "Có thể bạn quen" },
      countGroup: 0
    },
    {
      id: 9,
      user: { id: 209, fullName: "Mai Thanh Phong", avatar: "https://i.pravatar.cc/150?img=20" },
      type: { id: 2, name: "Nhóm chung" },
      countGroup: 2
    },
    {
      id: 10,
      user: { id: 210, fullName: "Bùi Thị Ngọc Lan", avatar: "https://i.pravatar.cc/150?img=21" },
      type: { id: 1, name: "Có thể bạn quen" },
      countGroup: 0
    }
  ];  
